import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyStepsComponent = () => {
  return (
    <div
      data-testid="partner-driver-steps-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center py-6`}
    >
      <Typography variant="body2" css={tw`text-shades-500`}>
        This driver has no collected-data steps
      </Typography>
    </div>
  )
}

export const EmptySteps = memo(EmptyStepsComponent)
